<template>
	<div class="games-container-wrapper">
		<HeaderComponent></HeaderComponent>
		<div class="content">
			<div class="section-1">
				<div class="slogan-wrapper">
					<div class="slogan">MAKE CASUAL MOBILE GAME WORLDWIDE</div>
					<div class="submit-button">DISCOVER</div>
				</div>
				<div class="background">
					<img src="../assets/img/GAMES-top.jpg" alt="">
				</div>
			</div>
			<div class="section-2">
				<GameItem 
					v-for="(item, index) in dataList" 
					:key="index" 
					:title="item.title" 
					:content="item.content" 
					:src="item.src"
					:iosUrl="item.iosUrl"
					:androidUrl="item.androidUrl"
				>
				</GameItem>
			</div>
		</div>
		<FooterComponent></FooterComponent>
	</div>
</template>

<script>
	import HeaderComponent from '../components/Header.component.vue';
	import GameItem from '../components/GameItem.component.vue';
	import FooterComponent from '../components/Footer.component.vue';

	export default {
		name: 'games',

		components: {
			HeaderComponent,
			GameItem,
			FooterComponent
		},

		data: () => ({
			dataList: [
				{
					title: 'Piano Tiles2',
					content: 'Loved by 900 millions of players, Piano Tiles 2™ with its simplicity, thrill-seeking and challenge-taking features, is always in the top ranks. Come to take the challenge!',
					src: require('../assets/img/pt2.png'),
					iosUrl: 'https://itunes.apple.com/us/app/piano-tiles-2/id1027688889?mt=8',
					androidUrl: 'https://play.google.com/store/apps/details?id=com.cmplay.tiles2&hl=en_US'
				},
				{
					title: 'Rolling Sky',
					content: [
						'Google Play Best Game!',
						'Drag the ball left or right to avoid all obstacles and try not to fall off the track! Let\'s control the ball and conquer the world by overcoming challenges'
					],
					src: require('../assets/img/RS.png'),
					iosUrl: 'https://itunes.apple.com/cn/app/rolling-sky/id1036661603?mt=8',
					androidUrl: 'https://play.google.com/store/apps/details?id=com.turbochilli.rollingsky&hl=en_US'
				},
				{
					title: 'Dancing Line',
					content: [
						'5M+ Total Downloads',
						'The key is to not only watch for obstacles and traps, but also play to the music. Listen to the beat and the melody, and after a short while you will find yourself doing better and better.'
					],
					src: require('../assets/img/DL.png'),
					iosUrl: 'https://itunes.apple.com/us/app/dancing-line/id1177953618?mt=8',
					androidUrl: 'https://play.google.com/store/apps/details?id=com.cmplay.dancingline'
				},
				{
					title: 'Bricks n Balls',
					content: 'Bricks n Balls is a classic and exciting brick game. Just play Bricks n Balls to relax your brain and get fun. The game is funny and challenging.',
					src: require('../assets/img/bnb.png'),
					iosUrl: 'https://itunes.apple.com/us/app/bricks-n-balls/id1331794412?mt=8',
					androidUrl: 'https://play.google.com/store/apps/details?id=com.cmplay.bricksnballs&hl=en_US'
				},
			]
		}),
	}
</script>

<style lang="less" scoped>
	.mobile {
		.games-container-wrapper {
			.content {
				.section-1 {
					img {
						height: 100%;
					    width: auto!important;
					    max-width: fit-content;
					}
					.slogan-wrapper {
						width: 90%;
						.slogan {
							font-size: .8rem;
						}
						.submit-button {
							max-width: none;
							padding: 18px 25px;
						}
					}
					
				}
			}		
		}
	}
	.games-container-wrapper {
		.content {
			.section-1 {
				overflow: hidden;
			    height: 640px;
			    position: relative;

			    .slogan-wrapper {
			    	position: absolute;
			    	top: 50%;
			    	left: 50%;
			    	transform: translate3d(-50%, -50%, 0);
			    	width: 80%;
			    	text-align: center;

			    	.slogan {
			    		margin-bottom: 48px;
			    		font-size: 40px;
			    		font-weight: 700;
			    		color: #ffffff;
			    		text-align: center;
			    	}

			    	.submit-button {
			    		border: 3px solid #fff!important;
			    		border-radius: 100px;
			    	    color: #fff;
			    	    cursor: pointer;
			    	    display: inline-block;
			    	    font-size: 24px;
			    	    font-weight: 700;
			    	    margin: 0 auto;
			    	    max-width: 90%;
			    	    padding: 25px 45px;
			    	    text-decoration: none;
			    	    transition: background .2s;
			    	    border: 3px solid #fff;
			    	}
			    }

				.background {
					position: absolute;
					width: 100%;
					top: 0;
					left: 0;
					z-index: -1;

					img {
						display: block;
						width: 100%;
					}
				}
			}
		}
	}
</style>